import { customEvent, aes256Decrypt } from "goi_common";
import { useMutation } from "react-query";

import { postWreathOrder, postWreathOrderStatus } from "@/apis/wreath";
import { useDialog } from "@/hooks/useDialog";

export const usePostWreathOrderMutation = ({ onClose }: { onClose: () => void }) => {
  const { onOpen, onClose: onDialogClose } = useDialog();

  // /** 결제 상태를 확인하는 곳 */
  const { mutate: checkPaymentStatus } = useMutation({
    mutationFn: (orderId: string) => {
      return postWreathOrderStatus(orderId);
    },
    onSuccess: (data) => {
      const paymentStatus = data.payment?.status;

      /** TODO: 결과화면 어떻게 보여줄 것인가??  */
      if (paymentStatus === "WAITING_FOR_DEPOSIT" || paymentStatus === "DONE") {
        onOpen({
          type: 1,
          header: "신청되었습니다.",
          footerProps: {
            text: "확인",
            onClick: () => {
              onDialogClose();
            },
          },
          children: (
            <>
              확인 후 즉시 발송해드리겠습니다.
              <br />
              감사합니다.
            </>
          ),
        });
        onClose();
      }
    },
    onError: () => {},
  });

  /** thebugo 결제 페이지로 submit 하는 훅 */
  const postWreathOrderMutation = useMutation({
    mutationFn: postWreathOrder,
    onSuccess: (data) => {
      const submitMayflowerForm = () => {
        const form = document.createElement("form");
        form.method = "POST";

        const formUrl = process.env.NEXT_PUBLIC_FLOWER_PAYMENT_URL as string;
        form.action = formUrl;

        // 새 창을 열고 참조 얻기
        const paymentWindow = window.open("", "paymentWindow");
        form.target = "paymentWindow";

        // 필요한 hidden input 필드를 생성하여 추가
        Object.entries(data).forEach(([key, value]) => {
          const input = document.createElement("input");
          input.type = "hidden";
          input.name = key;
          input.value = aes256Decrypt(value) as string;

          form.appendChild(input);
        });

        document.body.appendChild(form);
        form.submit();
        customEvent({
          newGtm: {
            action: "platform_flower_order_mayflower_try",
          },
        });

        return {
          paymentWindow,
          orderId: data.order_id,
        };
      };

      const { paymentWindow, orderId } = submitMayflowerForm();

      // 창의 closed 속성을 모니터링
      const checkWindowClosed = setInterval(() => {
        if (paymentWindow?.closed) {
          clearInterval(checkWindowClosed);
          /** api 요청할 부분 */
          customEvent({
            newGtm: {
              action: "platform_flower_order_closed_mayflower_payment",
            },
          });

          orderId && checkPaymentStatus(orderId);
        }
      }, 500);
    },
  });

  return postWreathOrderMutation;
};
